import { WebPaymentMethod } from '../iap.types';
import { paymentMethodsIcons, paymentMethodsNames } from './Config';
import { EncryptedLabel } from './EncryptedLabel';
import { CardLogos } from './Icons';

/**
 * Headerincluding logos and secure text.
 * @returns
 */
export function PaymentMethodHeader({
  paymentMethod,
}: {
  paymentMethod: WebPaymentMethod;
}) {
  return (
    <>
      <div class="paymentLogo">
        {paymentMethod === 'komoju_credit_card' ? (
          <CardLogos />
        ) : (
          paymentMethodsIcons[paymentMethod]
        )}
        {
          <div
            dangerouslySetInnerHTML={{
              __html: paymentMethodsNames[paymentMethod](),
            }}
          />
        }
      </div>
      <EncryptedLabel />
    </>
  );
}
